import React from "react";
import { Box } from "@mui/material";

type RightArrowProps = {
    left: number;
    top: number;
    color: string;
};

export const RightArrow = ({ left, top, color }: RightArrowProps) => (
    <Box 
        sx={{ 
            position: 'absolute', 
            left, 
            top, 
            width: 0, 
            height: 0, 
            borderTop: '4px solid transparent', 
            borderBottom: '4px solid transparent', 
            borderLeft: `6px solid ${color}` 
        }} 
    />
);